import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { useQuery as useQueryParams } from '@kiper/hooks';
import { Button } from '../FacialRegistration/components/common';
import * as S from './styles';

const EditFacialPhotoModal = ({
  isOpen,
  onClose,
  facialPhoto,
  primaryColor,
}) => {
  const [t] = useTranslation('personalized-invite');
  const history = useHistory();
  const querystring = useQueryParams();
  const guestHash = querystring?.get('q')?.replace(/ /g, '+') || '';
  const [isClosing, setIsClosing] = useState(false);

  const photoToDisplay = facialPhoto;

  useEffect(() => {
    if (!isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);

  if (!isOpen && !isClosing) return null;

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300);
  };

  const handleChangePhoto = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
      history.push(`/convite-personalizado/cadastro-facial?q=${guestHash}`);
    }, 300);
  };

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <S.Overlay
      onClick={handleOverlayClick}
      className={isClosing ? 'fade-out' : ''}
    >
      <S.ModalContainer>
        <S.ModalHeader>
          <S.ModalTitle>{t('edit-facial-photo-modal.title')}</S.ModalTitle>
          <S.CloseButton onClick={handleClose}>
            <MdClose size={14} />
          </S.CloseButton>
        </S.ModalHeader>

        <S.PhotoContainer>
          {photoToDisplay && (
            <S.FacialPhoto src={photoToDisplay} alt="Facial photo" />
          )}
        </S.PhotoContainer>

        <Button
          variant="outlined"
          onClick={handleChangePhoto}
          color={primaryColor}
        >
          {t('edit-facial-photo-modal.change-photo')}
        </Button>
      </S.ModalContainer>
    </S.Overlay>
  );
};

EditFacialPhotoModal.propTypes = {
  isOpen: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  facialPhoto: propTypes.string,
  primaryColor: propTypes.string,
};

EditFacialPhotoModal.defaultProps = {
  facialPhoto: '',
  primaryColor: undefined,
};

export default EditFacialPhotoModal;
